import { Link } from "react-router-dom";
import { memo } from "react";
import ChevronIcon from "@/common/images/icons/chevron.svg?react";
import "./BackButton.scss";

interface IBackButton {
  onClick?: () => void;
  link?: string;
}

export const BackButton: React.FC<IBackButton> = memo(({
  onClick,
  link,
}) => {
  const onClickHandle = () => {
    onClick && onClick();
  };

  return (
    <div className="BackButton">
      {link ? (
        <Link to={link} aria-label="Link to the previous page">
          <ChevronIcon />
        </Link>
      ) : (
        <button onClick={onClickHandle} aria-label="Back button">
          <ChevronIcon />
        </button>
      )}
    </div>
  );
});
